import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from 'app/base';

import { TrilhaDeAuditoria } from 'app/entity/trilha_de_auditoria.model';

@Component({
    selector: 'trilha-auditoria-historico',
    templateUrl: './trilha-auditoria-historico.component.html',
})
export class TrilhaAuditoriHistoricoComponent extends BaseStepComponent {

    @Input() SistemaOptions: SelectItem[];
    @Input() PerfilOptions: SelectItem[];
    @Input() FuncionalidadeOptions: SelectItem[];
    @Input() listaSistema: any[];
    @Input() listaStatus: any[];
    trilhaDados: TrilhaDeAuditoria;
    dadosHistorico: any;

    init() {
        this.service.Obter('trilha-auditoria', +this.activatedRoute.snapshot.paramMap.get('id')).subscribe(x => {
            this.trilhaDados = x;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/trilha-auditoria/crud/etapas/historico/trilha-auditoria-historico.component.ts